export default __webpack_public_path__ + "static/media/input.058acfe2.svg";